import { render } from "./App.vue?vue&type=template&id=48f42d1f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=48f42d1f&lang=scss"

import exportComponent from "/Users/rathasitjearnpasawarn/var/apps/happily-accounts/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__